import { Button, Card, Container } from "react-bootstrap";
import { Arrow90degLeft, Check, X } from "react-bootstrap-icons";
import { Currency } from "../../../../lib/components/Currency";
import { SubmitButton, CancelButton } from "../../shared";

const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

// Rendered only while rows are selected — the parent gates on selectedCount.
export function PayoutRunActionBar({
  selectedCount,
  selectedAmount,
  contractCount,
  bonusCount,
  chargebackCount,
  isSaving,
  onRequestDecline,
  onClear,
  onApprove,
  onReturnToPool,
}) {
  return (
    <div
      className="position-fixed bottom-0 start-0 end-0 d-flex justify-content-center commission-selection-bar"
      style={{ zIndex: 1030 }}
    >
      <Container className="px-3 pb-3" style={{ maxWidth: 900 }}>
        <Card className="bar-enter position-relative shadow-lg commission-selection-card">
          <span
            aria-hidden="true"
            className="bar-ring pe-none position-absolute top-0 start-0 end-0 bottom-0"
            style={{
              border: "2px solid var(--bs-success)",
              borderRadius: "inherit",
            }}
          />
          <Card.Body className="d-flex flex-wrap align-items-center gap-2 py-2 px-3">
            <div className="min-w-0">
              <p className="fw-medium mb-0">
                {plural(selectedCount, "record")} selected ·{" "}
                <span className="tnum">
                  <Currency amount={selectedAmount} />
                </span>
              </p>
              <p className="small text-body-secondary mb-0 mt-1 commission-selection-metrics">
                {contractCount > 0 && (
                  <span className="commission-selection-pill">
                    {plural(contractCount, "contract")}
                  </span>
                )}
                {bonusCount > 0 && (
                  <span className="commission-selection-pill">
                    {bonusCount} {bonusCount === 1 ? "bonus" : "bonuses"}
                  </span>
                )}
                {chargebackCount > 0 && (
                  <span className="commission-selection-pill">
                    {chargebackCount} {chargebackCount === 1 ? "chargeback" : "chargebacks"}
                  </span>
                )}
              </p>
            </div>
            <div className="ms-auto d-flex align-items-center gap-2">
              <Button
                variant="link"
                size="sm"
                onClick={onClear}
                disabled={isSaving}
                className="text-secondary text-decoration-none fw-medium"
              >
                Clear
              </Button>
              <SubmitButton
                text={`Approve ${selectedCount}`}
                color="green"
                onClick={onApprove}
                disabled={isSaving}
                icon={<Check size={16} />}
              />
              <SubmitButton
                text={`Decline ${selectedCount}`}
                color="red"
                onClick={onRequestDecline}
                disabled={isSaving}
                icon={<X size={16} />}
              />
              <CancelButton
                text={`Return to pool ${selectedCount}`}
                onClick={onReturnToPool}
                disabled={isSaving}
                icon={<Arrow90degLeft size={16} />}
              />
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}
